<template>
    <v-container>
        <v-card>
            <v-card-title>
                Administración de Usuarios
                <v-spacer></v-spacer>
                <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Buscar usuarios"
                    single-line
                    hide-details
                ></v-text-field>
            </v-card-title>
            <v-data-table
                :headers="headers"
                :options="options"
                :search="search"
                :items="users"
                item-key="username"
                :items-per-page="20"
                :footer-props="{
                    'items-per-page-options' : [20, 40, -1]
                }"
            >
                <template v-slot:top>
                    <v-toolbar flat>
                        <!-- Edit Dialog vvv  -->
                        <v-dialog v-model="dialog">
                            <v-card>
                                <v-card-title>
                                    {{ editedItem.username }} ({{ editedItem.email }})
                                </v-card-title>

                                <v-card-text>
                                    <v-container>
                                        <v-row>
                                            <!-- NAME -->
                                            <v-col cols="6" xs="12">
                                                <v-text-field v-model="editedItem.name" label="Nombre Completo" ></v-text-field>
                                            </v-col>
                                            <!-- PHONE -->
                                            <v-col cols="6" xs="12">
                                                <v-text-field v-model="editedItem.phone" label="Teléfono" ></v-text-field>
                                            </v-col>
                                        </v-row>

                                        <v-row>
                                            <!-- COMPANY -->
                                            <v-col cols="6" xs="12">
                                                <v-text-field v-model="editedItem.company" label="Compañía" ></v-text-field>
                                            </v-col>
                                            <!-- CITY -->
                                            <v-col cols="6" xs="12">
                                                <v-text-field v-model="editedItem.city" label="Localidad" ></v-text-field>
                                            </v-col>
                                        </v-row>

                                        <v-row>
                                            <!-- DEPARTMENT -->
                                            <v-col cols="6" xs="12">
                                                <v-text-field v-model="editedItem.department" label="Departamento" ></v-text-field>
                                            </v-col>
                                            <!-- POST -->
                                            <v-col cols="6" xs="12">
                                                <v-text-field v-model="editedItem.post" label="Cargo" ></v-text-field>
                                            </v-col>
                                        </v-row>

                                    </v-container>
                                </v-card-text>

                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="blue darken-1" text @click="closeEdit" >Cancelar</v-btn>
                                    <v-btn color="blue darken-1" text @click="saveEdit" >Guardar</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>

                        <!-- Edit Dialog ^^^ -->

                    </v-toolbar>
                </template>

                <template v-slot:item.actions="{ item }">
                    <v-icon class="mr-2" @click="editItem( item )">
                        mdi-pencil
                    </v-icon>
                    <v-icon class="mr-2" @click="deleteItem( item )">
                        mdi-delete
                    </v-icon>
                </template>


            </v-data-table>
        </v-card>
        <v-card>
            <v-card-text
                class="text-center pt-2"
            >
                <v-btn
                    v-if="undo.length > 0"
                    color="primary"
                    @click="undoAction">
                    {{ undo[0].label }}
                    <v-icon class="ml-2">mdi-undo</v-icon>
                </v-btn>
            </v-card-text>
        </v-card>
        <v-card>
            <v-card-text
                class="text-center pt-2"
                v-if="showCreateUsersButton"
            >
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            color="green"
                            dark
                            v-bind="attrs"
                            v-on="on"
                            @click="createNewUsers"
                        >
                            Crear {{ cognitoUsersToCreate.length }} usuario(s) nuevo(s)
                            <v-icon
                                class="ml-2"
                            >
                                mdi-plus
                            </v-icon>
                        </v-btn>
                    </template>
                    Usuarios: <span v-for="(user, userIndex) in cognitoUsersToCreate" :key="userIndex">{{ user.Username }} </span>
                </v-tooltip>
            </v-card-text>
        </v-card>
        <v-card>
            <v-card-text
                class="text-center pt-2"
                v-if="showUsersToDelete"
            >
                Los siguientes usuarios no existen en Cognito:
                <span v-for="(user, userIndex) in this.usersToDelete" :key="userIndex">
                    {{ user.username }}
                </span>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>

import { API, Auth, Hub } from 'aws-amplify';
import { mapGetters, mapActions } from 'vuex';
import { emptyUser, apiCreateUser, apiUpdateUser, apiDeleteUser } from '@/users.js';

const R = require( 'ramda' );

const {
    clone,
    concat,
    filter,
    find,
    head,
    includes,
    map,
    pipe,
    prop,
    propEq,
    tail,
    // toString,
} = R;


////////////////////////////////////////////////////////////////////////////////////////////////////
// Cognito Users

/*
 * listUsers -> {
 *     Users : [ {
 *         Username : string,
 *         Enabled : boolean,
 *         UserStatus : string, // CONFIRMED
 *         UserCreateDate : string, "2020-07-29T02:12:56.509Z"
 *         UserLastModifiedDate : string,
 *         Attributes : [
 *             {
 *                 Name : string,   // email, sub, email_verified, phone_number_verified, phone_number
 *                 Value : String,
 *             }],}]}
 */

/**
 * @param attributeName
 * @param cognito User
 * @return the value of the given attribute for the user
 */
const cognitoUserAttributeValue = attributeName => pipe(
    prop( 'Attributes' ),
    find( propEq( 'Name', attributeName ) ),
    prop( 'Value' )
);

/**
 * @param cognito User
 * @return the user's email
 */
const cognitoUserEmail = cognitoUserAttributeValue( 'email' )

/**
 * @param cognito User
 * @return the user's phone
 */
const cognitoUserPhone = cognitoUserAttributeValue( 'phone_number' )



/**
 * Convert a cognito user into one of our Users
 */
const convertCognitoUser = cognitoUser => {
    const user = emptyUser();
    user.username = cognitoUser.Username;
    user.email    = cognitoUserEmail( cognitoUser );
    user.phone    = cognitoUserPhone( cognitoUser ) || '';

    return user;
}
;

/**
 * @param {Array} list of cognito users
 * @return A Promise of all the promises that return the new Users
 */
const makeNewUsers = pipe(
    map( convertCognitoUser ),
    map( apiCreateUser ),
    createUserPromises => Promise.all( createUserPromises )
);

/**
 * Create new Users for all the cognitor users for which we don't
 * yet have one.
 */
const reconcileUsers = async ( cognitoUsers, users ) => {
    // console.log( 'Reconciliation', { cognitoUsers, users } );

    const usernames = map( prop( 'username' ), users ),
          isExistingUsername = includes( R.__, usernames ),
          cognitoUsersToCreate = filter( cognitoUser => ! isExistingUsername( cognitoUser.Username ),
                                         cognitoUsers ),
          cognitoUsernames = map( prop( 'Username' ),  cognitoUsers ),
          isExistingCognitoUsername = includes( R.__, cognitoUsernames ),
          usersToDelete = filter( user => ! isExistingCognitoUsername( user.username ),
                                  users );

    console.log( `There are ${cognitoUsers.length} cognito users, ${users.length} in the database, ${cognitoUsersToCreate.length} to create, and ${usersToDelete.length} users to delete` );

    // console.log( { cognitoUsersToCreate : map( prop( 'Username' ), cognitoUsersToCreate ) } );
    // console.log( { usersToDelete : map( prop( 'username' ), usersToDelete ) } );

    makeNewUsers;
    // makeNewUsers( cognitoUsersToCreate ).catch( error => {
    //     console.log( `There were errors creating new users ${map( cognitoUserEmail, cognitoUsersToCreate )}`,
    //                  error );
    // } );

    return { cognitoUsersToCreate, usersToDelete };
};


////////////////////////////////////////////////////////////////////////////////////////////////////
// GUI

export default {
    name: 'UserAdministrationView',

    data : () => ({
        globalState : {},
        search : '',
        options : {
            sortBy : ['name'],
            multiSort : true,
        },
        headers : [
            { text : 'Nombre Completo', value : 'name' },
            { text : 'Usuario',         value : 'username' },
            { text : 'Correo',          value : 'email' },
            { text : 'Localidad',       value : 'city', groupable : true },
            { text : 'Compañía',        value : 'company' },
            { text : 'Departamento',    value : 'department' },
            { text : 'Cargo',           value : 'post' },
            { text : 'Teléfono',        value : 'phone' },
            { text : '',                value : 'actions', sortable : false }
        ],
        dialog : false,
        editedItem : emptyUser(),

        /**
         * {Array} of Objects { label, action }
         */
        undo : [],

        cognitoUsersToCreate : [],
        usersToDelete : [],
    }),

    created() {
        this.globalState = this.$root.$data.globalState;
        Hub.listen( 'monitor', data => {
            if ( ['ev:setAccount'].includes( data.payload.event ) )
                this.fetchUsers();
        } );
        this.apiSubscribeToUserEvents();
        this.fetchUsers();
    },

    destroyed() {
    },

    mounted() {
    },

    computed : {
        ... mapGetters( {
            users : 'getUsers',
            hasCompleteUsers : 'hasCompleteUsers',
        } ),

        showCreateUsersButton() {
            // console.log( { showCreateUsersButton : this.hasCompleteUsers && this.cognitoUsersToCreate.length > 0 } );

            return this.hasCompleteUsers && this.cognitoUsersToCreate.length > 0
        },

        showUsersToDelete() {
            return this.hasCompleteUsers && this.usersToDelete.length > 0;
        },

    },

    methods : {

        ... mapActions( [
            'apiListUsers',
            'apiSubscribeToUserEvents',
        ] ),

        createNewUsers() {
            if ( ! this.hasCompleteUsers ) {
                console.log( `Not creating ${this.cognitoUsersToCreate.length} users since we don't yet have the full user list` );
                return;
            }

            makeNewUsers( this.cognitoUsersToCreate ).then(
                () => this.fetchUsers(),
                error => {
                    console.log( `There were errors creating new users ${map( cognitoUserEmail, this.cognitoUsersToCreate )}`,
                                 error );
                } );
        },

        editItem( item ) {
            // console.log( { editItem : item } );
            this.editedItem = clone( item );
            this.dialog = true;
        },

        deleteItem( item ) {
            // console.log( { deleteItem : toString( item ) } );
            const undoItem = {
                label : `Recrear usuario ${item.username}`,
                action : () => apiCreateUser( item ),
            };

            this.undo = [undoItem, ...this.undo];

            apiDeleteUser( item );
        },

        undoAction() {
            const { action } = head( this.undo );
            this.undo = tail( this.undo );

            action();
        },

        closeEdit() {
            this.dialog = false;
            this.$nextTick( () => {
                this.editedItem = emptyUser();
            } );
        },

        saveEdit() {
            // console.log( { 'user to udpate' : this.editedItem } );

            apiUpdateUser( this.editedItem )
            this.closeEdit();
        },

        async fetchUsers() {
            const cognitoUsers = await this.adminQueryListUsers();

            await this.apiListUsers();

            reconcileUsers( cognitoUsers, this.users ).then( ( { cognitoUsersToCreate, usersToDelete } ) => {
                this.cognitoUsersToCreate = cognitoUsersToCreate;
                this.usersToDelete = usersToDelete;
            } );
        }, // fetchUsers

        async adminQueryListUsers() {
            // See https://docs.amplify.aws/cli/auth/admin#example

            const jwtToken = ( await Auth.currentSession() ).getAccessToken().getJwtToken();
            const init = {
                headers : {
                    'Content-Type'  : 'application/json',
                    'Authorization' : jwtToken
                },
            };

            let token = false;
            let users = [];
            do {
                const query = '/listUsers' + ( token ? `?token=${ encodeURIComponent( token ) }` : '' );

                const result = await API.get( 'AdminQueries', query, init );

                users = concat( users, result.Users );
                token = result.NextToken;
            } while ( token );

            return users;
        }, // adminQueryListUsers
    },
}

</script>
